<div>
  <div class="content-icon">
    <i class="one-icon-outline-notification" aria-hidden="true"></i>
  </div>
  <div class="content-message">No notices right now, you are up-to-date</div>
</div>
